import { Label } from "simplydo/react/ui/label";
import { Popup } from "simplydo/react/ui/popup";

import type { IdeaDisplayField as IdeasLibDisplayField } from "./types";

type IdeaDisplayField = {
  id: string;
  title: string;
  type?: string;
  value: string | string[];
};

const toDisplayField = (
  field: IdeasLibDisplayField,
): IdeaDisplayField | null => {
  if (
    field.id === undefined ||
    field.value === undefined ||
    field.value === null
  ) {
    return null;
  }
  const value =
    typeof field.value === "string" || Array.isArray(field.value)
      ? field.value
      : String(field.value);
  return {
    id: field.id,
    title: field.title ?? field.name ?? field.id,
    type: field.type,
    value,
  };
};

type IdeaDisplayFieldsProps = {
  fields: IdeasLibDisplayField[];
  showBorder?: boolean;
};

const IdeaDisplayFields = ({ fields }: IdeaDisplayFieldsProps) => {
  const normalizedFields = fields
    .map(toDisplayField)
    .filter((field): field is IdeaDisplayField => field !== null);
  if (!normalizedFields.length) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px" }}
      >
        {normalizedFields.map((field) => (
          <Popup
            key={field.id}
            position="right center"
            trigger={
              <Label
                basic
                size="small"
                style={{
                  width: "100%",
                  margin: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {field.type === "optionMultiple" && Array.isArray(field.value)
                  ? field.value.join(", ")
                  : field.value}
              </Label>
            }
          >
            {
              <div>
                <b>{field.title}</b>
                <div>
                  {field.type === "optionMultiple" && Array.isArray(field.value)
                    ? field.value.join(", ")
                    : field.value}
                </div>
              </div>
            }
          </Popup>
        ))}
      </div>
    </div>
  );
};

export default IdeaDisplayFields;
